updatePaymentCreditCardOptions